import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { merge } from 'lodash';
import { ServerConfigModel } from '../../../../technical/version/server-config.model';

type StartPageWidth = 'narrow' | 'wide';

@Component({
  selector: 'ppb-start-container',
  templateUrl: './ppb-start-container.component.html',
  styleUrls: ['./ppb-start-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbStartContainerComponent implements OnInit {
  private static readonly DEFAULT_RULES_URL = 'https://www.pse.pl/portal-partnera-biznesowego/regulamin';


  @Input() width: StartPageWidth = 'narrow';
  @Input() showUserIcon?: boolean = true;

  configuration: ServerConfigModel;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.configuration = this.determineConfiguration();
  }

  private determineConfiguration(): ServerConfigModel {
    let conf = this.route.snapshot.data.configuration;
    if (!conf || !conf.agreements || !conf.agreements.rulesUrl) {
      conf = merge({}, conf, {agreements: {rulesUrl: PpbStartContainerComponent.DEFAULT_RULES_URL}});
    }
    return conf;
  }
}
